import React from 'react';
import Headline from '../headline';

function SecondStageHeader() {
  return (
    <Headline
      title='Automatize suas vendas!'
      description='Aqui você encontra outras ferramentas para ajudar nas suas vendas e gestão.'
    />
  );
}

export default SecondStageHeader;
